import Undo from "@myvp/shared/src/icons/undo"
import { Medium14 } from "@myvp/shared/src/typography"
import React from "react"
import { useParams } from "react-router"
import VaultResourceLink from "src/components/vault-resource-link"
import { useIntl } from "react-intl"
import { css } from "@emotion/react"
import { DO_NOT_TRANSLATE_CONSTANTS } from "@myvp/shared/src/constants"

const VaultStudyLink = (props: { variant?: "white" | "default" }) => {
  const { formatMessage } = useIntl()
  const params = useParams<"globalSponsorStudyId">()

  // globalSponsorStudyId format is {vaultId}_{sponsorStudyId}, e.g. 147168_V5400000002R008
  const sponsorStudyId = params.globalSponsorStudyId?.split("_")[1]

  return (
    sponsorStudyId && (
      <VaultResourceLink
        resourceName="study"
        resourceId={sponsorStudyId}
        css={[
          (theme) => css`
            display: flex;
            align-items: center;
            color: ${theme.palette.content.neutral.default};
            z-index: 1;

            text-decoration: none;
            ${Medium14} {
              padding-inline-end: 16px;
            }
            span {
              :hover {
                background-color: ${theme.palette.surface.neutral.hover};
              }
              padding: 4px;
              display: flex;
              align-items: center;
              gap: 4px;
              margin-left: 11px;
              border-radius: 4px;
              border: 1px solid ${theme.palette.border.neutral.default};
            }
          `,
          props.variant === "white"
            ? (theme) => css`
                color: ${theme.palette.content.neutral.inverse};
                svg {
                  path {
                    stroke: ${theme.palette.content.neutral.inverse};
                  }
                }
                span {
                  border: unset;
                  :hover {
                    background-color: unset;
                  }
                }
              `
            : null,
        ]}
      >
        <span>
          <Undo color="black" />
          <Medium14>
            {formatMessage(
              { id: "sponsorStudyNav.returnToVault" },
              { vault: DO_NOT_TRANSLATE_CONSTANTS.vault }
            )}
          </Medium14>
        </span>
      </VaultResourceLink>
    )
  )
}

export default VaultStudyLink
